import React, { useState, useEffect, useRef } from 'react';
import { useParams } from "react-router-dom";

import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, memoActionDel } from '@laramie/ui';
import { APIS } from '../../config/apis';
import { ServerRequest } from '../../utils/apiweb';
import { useForm, useNav, useReporte, useFormErrors } from '../../components/hooks';
import { useDispatch, useSelector } from 'react-redux';
import { Loading, TableCustom, SectionHeading, InputCuenta, InputNumber, DatePickerCustom, FormLabel, FormError } from '../../components/common';
import ConfirmacionReciboModal from '../../components/controls/ConfirmacionReciboModal';
import { getDateNow, getFormatNumber } from '../../utils/convert';
import { OpenObjectURL } from '../../utils/helpers';


function PagoACuentaView() {

    //parametros url
    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNav()

    const {cache} = useSelector( (state) => state.memo );

    const entityInit = {
        cuenta: {
            id: 0,
            numeroCuenta: '',
            numeroWeb: '',
            idEstadoCuenta: 0,
            idTipoTributo: 0,
            idTributo: 0,
            fechaAlta: null,
            fechaBaja: null,
            idContribuyentePrincipal: 0,
            idDireccionPrincipal: 0,
            idDireccionEntrega: 0
        }
    };

    //hooks
    const [state, setState] = useState({
        idCuenta: 0,
        fechaVencimiento: null,
        items: [],
        loading: false,
        disbled: false
    });
    const [cuenta, setCuenta] = useState(entityInit.cuenta);
    const [itemsDeuda, setItemsDeuda] = useState([]);
    const [importeActualizadoTotal, setImporteActualizadoTotal] = useState(0);
    const [messageConfirm, setMessageConfirm] = useState({
        show: false,
        title: "",
        data: null,
        callback: null
    });

    const reciboResumidoRef = useRef(false);

    useEffect(() => {
        const data = cache[params.processKey];
        if (data) { //el cache tiene datos
            setState(prevState => {
                return {...prevState, idCuenta: data.value.idCuenta, fechaVencimiento: data.value.fechaVencimiento, items: data.value.items};
            });
        }
        else {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, "No se pudo recuperar la información de la solicitud");
        }
    }, []);

    const [ generateReporte ] = useReporte({
        callback: (reporte, buffer, message, filename) => {
            if (buffer)
                OpenObjectURL(filename ?? `${reporte}.pdf`, buffer);
            else
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        }
    });

    const [formValues, formHandle, , formSet] = useForm({
        importe: 0
    });

    const getErrors = () => {

        const errors = {};

        if (formValues.importe === 0) errors.importe = 'Ingresá un número mayor a cero';

        return errors;
    }

    const { errorOf, validate } = useFormErrors(getErrors);

    //definiciones
    const cellV = (props) =>    <div className='action'>
                                    <div>
                                        <span className="material-symbols-outlined" style={{color: `#${props.row.original.color}`}}>circle</span>
                                    </div>
                                </div>

    const tableColumns = [
        { Header: 'Período', accessor: 'periodo', width: '15%', alignCell: 'right', disableSortBy: true },
        { Header: 'Cuota', accessor: 'cuota', width: '15%', alignCell: 'right', disableSortBy: true },
        { Header: 'Importe actualizado', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeTotal', width: '20%', alignCell: 'right', disableSortBy: true },
        { Header: 'Importe a cancelar', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeACancelar', width: '20%', alignCell: 'right', disableSortBy: true },
        { Header: 'Pago', accessor: 'estado', width: '25%', disableSortBy: true },
        { Header: '', Cell: cellV, id:'abm', accessor: 'id', width: '5%', disableGlobalFilter: true, disableSortBy: true }
    ];

    //handles
    const handleClickVolver = () => {
        dispatch(memoActionDel(params.processKey));
        navigate({ to: "../deuda/edit/" + cuenta.id, });
    }
    const handleClickCheckPagoACuenta = () => {
        if (state.idCuenta === 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, "La cuenta no está definida");
            return;
        }
        if (!validate()) return;

        if (state.fechaVencimiento === null) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, "Debe ingresar la fecha de Vencimiento");
            return;
        }

        let data = {
            idCuenta: state.idCuenta,
            importe: formValues.importe,
            fechaVencimiento: state.fechaVencimiento,
            items: state.items
        };
        CheckPagoACuenta(data);
    }
    const handleClickAddPagoACuenta = () => {
        if (state.idCuenta === 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, "La cuenta no está definida");
            return;
        }
        if (!validate()) return;

        if (state.fechaVencimiento === null) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, "Debe ingresar la fecha de Vencimiento");
            return;
        }

        let data = {
            idCuenta: state.idCuenta,
            importe: formValues.importe,
            fechaVencimiento: state.fechaVencimiento,
            items: state.items
        };
        setMessageConfirm({
            show: true,
            title: "Crear pago a cuenta",
            data: data,
            callback: (data) => AddPagoACuenta(data)
        });
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
          const message = error.message;
          ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
          setState(prevState => {
            return {...prevState, loading: false};
          });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
              return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
          return {...prevState, loading: false};
        });
    }
    const callbackSuccessCheckPagoACuenta = (response) => {
        response.json()
        .then((data) => {

            let importeActualizadoTotal = 0;
            data.forEach((item, index) => {
                item.color = (item.importeACancelar > 0 && item.importeACancelar === item.importeTotal) ? '359538' : (item.importeACancelar > 0 && item.importeACancelar < item.importeTotal) ? 'e0df23' : 'f20c0c';
                item.estado = (item.importeACancelar > 0 && item.importeACancelar === item.importeTotal) ? 'COMPLETO' : (item.importeACancelar > 0 && item.importeACancelar < item.importeTotal) ? 'PARCIAL' : 'IMPAGO';
                importeActualizadoTotal += item.importeTotal;
            });
            setImporteActualizadoTotal(importeActualizadoTotal);

            setItemsDeuda(data);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }
    const callbackSuccessAddPagoACuenta = (response) => {
        response.json()
        .then((data) => {
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Pago a cuenta generado correctamente", () => {
                handleClickVolver();
            });
            setState(prevState => {
                return {...prevState, loading: false};
            });
            PrintRecibo(data.idCuentaPago);
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }

    //funciones
    function PrintRecibo(idCuentaPago) {
        const paramsReporte = {
            idCuentaPago: idCuentaPago,
            reciboResumido: reciboResumidoRef.current
        }
        generateReporte("CuentaCorrientePagoACuenta", paramsReporte);
    }
    function CheckPagoACuenta(data) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const dataBody = data;
        const paramsUrl = `/pago-acuenta`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.CUENTA_CORRIENTE_ITEM,
            paramsUrl,
            dataBody,
            callbackSuccessCheckPagoACuenta,
            callbackNoSuccess,
            callbackError
        );

    }
    function AddPagoACuenta(data) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const dataBody = data;
        const paramsUrl = `/pago-acuenta`;

        ServerRequest(
            REQUEST_METHOD.POST,
            null,
            true,
            APIS.URLS.CUENTA_CORRIENTE_ITEM,
            paramsUrl,
            dataBody,
            callbackSuccessAddPagoACuenta,
            callbackNoSuccess,
            callbackError
        );

    }
    

    return (
    <>

        <Loading visible={state.loading}></Loading>

        {messageConfirm.show && 
            <ConfirmacionReciboModal
                title={messageConfirm.title}
                message="Vas a crear el pago a cuenta. ¿Querés continuar?"
                confirmLabel="Crear"
                onDismiss={() => {
                    setMessageConfirm({ show: false, title: "", data: null, callback: null });
                }}
                onConfirm={({ reciboResumido }) => {
                    reciboResumidoRef.current = reciboResumido;
                    if (messageConfirm.callback) {
                        messageConfirm.callback(messageConfirm.data);
                    }
                    setMessageConfirm({ show: false, title: "", data: null, callback: null });
                }}
            />
        }

        <SectionHeading
            titles={[
                { title: 'Tributos' },
                { title: 'Cálculo de deuda' },
                { title: 'Pago a cuenta', },
            ]}
        />

        <section className='section-accordion'>

            <div className='row form-basic m-top-10'>
                <div className="col-12 col-lg-5">
                    <FormLabel htmlFor="cuenta" required>Cuenta</FormLabel>
                    <InputCuenta
                        name="cuenta"
                        placeholder=""
                        className="form-control"
                        value={state.idCuenta}
                        onUpdate={({target}) => {
                            const cuenta = target.row;
                            if (cuenta) {
                                setCuenta(cuenta);
                            }
                            else {
                                setCuenta(entityInit.cuenta);
                            }
                        }}
                        disabled={true}
                    />
                </div>
            </div>
            <div className='row form-basic m-top-10'>
                <div className="col-12 col-lg-3">
                    <FormLabel htmlFor="importe" required>Importe de pago a cuenta</FormLabel>
                    <InputNumber
                        name="importe"
                        placeholder=""
                        className={`form-control ${errorOf('importe') ? 'is-invalid' : ''}`}
                        onChange={formHandle}
                        value={formValues.importe}
                        precision={2}
                    />
                    <FormError message={errorOf('importe')} />
                </div>
                <div className="col-12 col-lg-2">
                <label htmlFor="fechaVencimiento" className="form-label">Vto. VEP</label>
                    <DatePickerCustom
                        name="fechaVencimiento"
                        placeholder=""
                        className="form-control"
                        onChange={formHandle}
                        value={ state.fechaVencimiento }
                        disabled={true}
                    />
                    <FormError />
                </div>
                <div className="col-12 col-lg-3">
                    <button className="btn btn-primary m-top-27 float-end" onClick={ (event) => handleClickCheckPagoACuenta() }>Generar</button>
                </div>
            </div>
            <div className='row form-basic m-top-10 m-bottom-20'>
                <div className="col-12 col-lg-8">
                    <label className="form-label">Verificación de imputación</label>
                    <TableCustom
                        showFooter={false}
                        showFilterGlobal={false}
                        className={'TableCustomBase'}
                        columns={tableColumns}
                        data={itemsDeuda}
                    />
                </div>
            </div>
            <div className='row form-basic m-top-10 m-bottom-20'>
                <label className="form-label">Importe actualizado de períodos seleccionados: $ {getFormatNumber(importeActualizadoTotal,2)}</label>
            </div>

        </section>

        <footer className='footer footer-action'>
            <div className='footer-action-container'>
                <button className="btn back-button float-start" onClick={ (event) => handleClickVolver() }>Volver</button>
                {!state.disbled &&
                <button className="btn action-button float-end m-left-10" onClick={ (event) => handleClickAddPagoACuenta() }>Crear pago a cuenta</button>
                }
            </div>
        </footer>
        
    </>
    )
}

export default PagoACuentaView;
